import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleTitleClick = () => {
    navigate("/sessions");
  };

  const handleSettingsClick = () => {
    navigate("/settings");
  };

  return (
    <header className="dashboard-header">
      <h1 onClick={handleTitleClick} style={{ cursor: "pointer" }}>
        cupdat
      </h1>
      <div className="user-section">
        <button onClick={handleSettingsClick} className="settings-btn">
          Settings
        </button>
        <button onClick={onLogout} className="logout-btn">
          Sign Out
        </button>
      </div>
    </header>
  );
};

export default Header;
